import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import config from 'constants/config'
import {
  LUXURY_ESCAPES,
  LE_AGENT_HUB,
  LE_AGENT_HUB_CVFR,
} from 'constants/brands'

const BRANDS_WITH_HOTELS_LABEL = [LUXURY_ESCAPES, LE_AGENT_HUB, LE_AGENT_HUB_CVFR]

/**
 * Returns a mapping of SearchVertical to localized labels
 * This hook should be used instead of the deprecated `label` property on SearchVerticalItem
 *
 * Labels are brand-specific where needed (e.g., "Hotels" for luxuryescapes vs "Hotels & Resorts" for other brands)
 */
function useSearchVerticalLabels(): Record<App.SearchVertical, string> {
  const intl = useIntl()

  // Luxury Escapes and Agent Hub brands use "Hotels", other brands use "Hotels & Resorts"
  const useHotelsLabel = BRANDS_WITH_HOTELS_LABEL.includes(config.BRAND)

  return useMemo(() => ({
    hotels: useHotelsLabel
      ? intl.formatMessage({
          id: 'A09ajnhtg0',
          defaultMessage: 'Hotels',
          description: 'Label for hotels search vertical',
        })
      : intl.formatMessage({
          id: 'VUFn8eqtv/',
          defaultMessage: 'Hotels & Resorts',
          description: 'Label for hotels & resorts search vertical',
        }),
    flights: intl.formatMessage({
      id: '7CMT9iC8eY',
      defaultMessage: 'Flights',
      description: 'Label for flights search vertical',
    }),
    tours: intl.formatMessage({
      id: 'XepiexGd+I',
      defaultMessage: 'Tours',
      description: 'Label for tours search vertical',
    }),
    cruises: intl.formatMessage({
      id: 'A2/47AK0hx',
      defaultMessage: 'Cruises',
      description: 'Label for cruises search vertical',
    }),
    experiences: intl.formatMessage({
      id: '6RENVjdmDI',
      defaultMessage: 'Experiences',
      description: 'Label for experiences search vertical',
    }),
    'car-hire': intl.formatMessage({
      id: 'Mdtrr61PR/',
      defaultMessage: 'Car Hire',
      description: 'Label for car hire search vertical',
    }),
    'homes-and-villas': intl.formatMessage({
      id: 'YHBlpI9KI0',
      defaultMessage: 'Homes & Villas',
      description: 'Label for homes and villas search vertical',
    }),
    merchandise: intl.formatMessage({
      id: '1BbdQaID9M',
      defaultMessage: 'Shop',
      description: 'Label for merchandise/shop search vertical',
    }),
  }), [intl, useHotelsLabel])
}

export default useSearchVerticalLabels
